import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/roles',
    meta: {
      auth: true,
      permissions: [PermissionEnum.ROLES],
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'roles',
        component: () => import('~/roles/pages/Index.vue'),
      },
      {
        path: '/roles/create',
        name: 'CreateRole',
        component: () => import('~/roles/pages/Create.vue'),
      },
      {
        path: '/roles/edit/:id',
        name: 'EditRole',
        component: () => import('~/roles/pages/Edit.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
];
